import { Ref } from 'vue';
import { Database, DatabaseContentPage, DatabaseEntry, DatabaseField, DatabaseFieldType, DatabasePageBlock, DatabaseTemplate } from '~/api-client';
import { COMPARISON_OPERATOR_MAP } from '~/modules/common/services/util/util';

export const isVisible = (obj: DatabaseField | DatabaseContentPage, database: Database|DatabaseTemplate, entry: DatabaseEntry | undefined) => {
  if (!obj || !obj.visibilityRules || obj.visibilityRules.length === 0) {
    // always show if no visibility rules are defined
    return true;
  };
  return obj.visibilityRules.map((rule) => {
    const operator = rule.operator;
    if (!operator) {
      return true;
    }
    const fieldRef = rule.fieldId;
    const compareField = database.fields?.find(f => f.id == fieldRef);
    if (!compareField) {
      return true;
    }
    const compareFn = COMPARISON_OPERATOR_MAP.get(compareField.fieldType as DatabaseFieldType)?.get(operator);
    if (!compareFn) {
      return true;
    }
    const compareValue = entry?.fieldsValues?.[compareField.id!];
    return compareFn(compareValue, rule.value);
  }).reduce((acc, val) => acc && val, true);
}

export default function useVisibilityRules(obj: Ref<DatabaseField | DatabaseContentPage | DatabasePageBlock>, database: Ref<Database | DatabaseTemplate>, entry: Ref<DatabaseEntry | undefined>) {
  const isVisibleBasedOnCondition = computed(() => {
    return isVisible(unref(obj), unref(database), unref(entry));
  });

  // check other fields
  watch(() => entry.value?.fieldsValues?.[obj.value?.id ?? ''], (newValue) => {
    database.value.fields?.filter((field) => field.visibilityRules)
      .filter((field) => field.visibilityRules!.some((rule) => rule.fieldId === obj.value.id))
      .forEach((field) => {
        if (!isVisible(field, unref(database), unref(entry))) {
          entry.value!.fieldsValues![field.id!] = undefined;
        }
      });
  });

  watch(isVisibleBasedOnCondition, (newValue) => {
    if (!newValue && entry.value?.fieldsValues) {
      entry.value.fieldsValues[obj.value.id!] = undefined;
    }
  });

  return {
    isVisibleBasedOnCondition
  };
};